module.exports = __webpack_public_path__ + "static/greycliffcf-extraboldoblique-webfont-627d3aa27c064fb5656d4c9e361d0a8c.woff2";